'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dCredential$002dUsage from "./presto.types$-Credential-Usage.js";
var $p;
/** @constructor */
function $c_Lpresto_types$CredentialUsage$() {
}
export { $c_Lpresto_types$CredentialUsage$ as $c_Lpresto_types$CredentialUsage$ };
$p = $c_Lpresto_types$CredentialUsage$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$CredentialUsage$;
/** @constructor */
function $h_Lpresto_types$CredentialUsage$() {
}
export { $h_Lpresto_types$CredentialUsage$ as $h_Lpresto_types$CredentialUsage$ };
$h_Lpresto_types$CredentialUsage$.prototype = $p;
$p.l = (function() {
  return "CredentialUsage";
});
$p.cFK = (function(x$0) {
  return new $j_presto$002etypes$0024$002dCredential$002dUsage.$c_Lpresto_types$CredentialUsage((!(!x$0.j(0))), x$0.j(1), x$0.j(2), x$0.j(3), x$0.j(4), x$0.j(5));
});
var $d_Lpresto_types$CredentialUsage$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$CredentialUsage$, "presto.types$CredentialUsage$", ({
  Zp: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$CredentialUsage$ as $d_Lpresto_types$CredentialUsage$ };
var $n_Lpresto_types$CredentialUsage$;
function $m_Lpresto_types$CredentialUsage$() {
  if ((!$n_Lpresto_types$CredentialUsage$)) {
    $n_Lpresto_types$CredentialUsage$ = new $c_Lpresto_types$CredentialUsage$();
  }
  return $n_Lpresto_types$CredentialUsage$;
}
export { $m_Lpresto_types$CredentialUsage$ as $m_Lpresto_types$CredentialUsage$ };
//# sourceMappingURL=presto.types$-Credential-Usage$.js.map
